import {Component, Input, OnInit} from '@angular/core';
import {DrawerContent, DrawerType} from '../../../../../layouts/right-drawer/right-drawer.component';
import {FeatureFlagEnum} from '../../../../../shared/models/configuration.model';
import {ActivatedRoute, Router} from '@angular/router';
import { NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-right-panel-button',
  templateUrl: './right-panel-button.component.html',
  styleUrl: './right-panel-button.component.scss',
  imports: [NgClass, MatIconButton, MatTooltip, MatIcon],
})
export class RightPanelButtonComponent implements OnInit {
  @Input() drawerType: DrawerType;
  @Input() badgeNumber: number;

  activeDrawer: DrawerContent;

  protected readonly DrawerContent = DrawerContent;
  protected readonly FeatureFlagEnum = FeatureFlagEnum;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.activeDrawer = params.drawer;
    });
  }

  showDrawerPanel(drawer: DrawerContent) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { drawer },
      queryParamsHandling: 'merge',
    });
  }
}
